import { AdminTag, Banner, BrandMark, Button, EnvTag } from "@guestpilot/ui-kit";
import { ENV } from "../env";
import { useAuth } from "../auth";

/** Outside the shell: one primary button, no password field, no sign-up, no forgot-password (BR-241). Failures show inline here. */
export function SignIn({ error }: { error?: string | null }) {
  const auth = useAuth();
  return (
    <div className="gp-signin">
      <div style={{ position: "absolute", top: "var(--space-16)", right: "var(--space-16)" }}>
        <EnvTag
          environment={ENV.environment}
          label={
            ENV.environment === "production"
              ? "Production"
              : ENV.environment === "staging"
                ? "Staging"
                : "Development"
          }
        />
      </div>
      <main className="gp-signin-card">
        <div className="gp-row">
          <BrandMark />
          <span className="t-body-strong">GuestPilot</span>
          <AdminTag>ADMIN</AdminTag>
        </div>
        <h1 className="t-title-lg" style={{ margin: 0 }}>
          Sign in to GuestPilot Admin
        </h1>
        {error ? <Banner tone="danger">{error}</Banner> : null}
        <Button variant="primary" size="lg" onClick={() => void auth.signIn()}>
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden focusable="false">
            <use href="/microsoft-logo.svg#mark" />
          </svg>
          Sign in with Microsoft
        </Button>
        <p className="t-body-sm gp-muted" style={{ margin: 0 }}>
          Access is limited to GuestPilot staff signing in with their organisation account (Microsoft Entra
          ID).
        </p>
      </main>
    </div>
  );
}
